/** Primary → response pairs shown side-by-side in the try editor. */
export const EDITOR_PAIRS: Record<string, string> = {
  'pain.001': 'pain.002',
  'pain.013': 'pain.014',
  'pacs.008': 'pacs.002',
  'camt.056': 'camt.029',
  'acmt.023': 'acmt.024',
};

/** When the user picks a response message, open the primary with its pair. */
const RESPONSE_TO_PRIMARY: Record<string, string> = Object.fromEntries(
  Object.entries(EDITOR_PAIRS).map(([primary, response]) => [response, primary]),
);

export function editorPairFor(short: string): string | undefined {
  return EDITOR_PAIRS[short];
}

/** Normalize selection so response messages open as primary + pair. */
export function editorPrimaryShort(short: string): string {
  return RESPONSE_TO_PRIMARY[short] ?? short;
}
